import { render, staticRenderFns } from "./ChatbotButton.vue?vue&type=template&id=67ee0448&scoped=true"
import script from "./ChatbotButton.vue?vue&type=script&lang=js"
export * from "./ChatbotButton.vue?vue&type=script&lang=js"
import style0 from "./ChatbotButton.vue?vue&type=style&index=0&id=67ee0448&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee0448",
  null
  
)

export default component.exports